/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Colleagues_CoveredInputs */



/**
* | output |
* | --- |
* | "Wundo follows all your one-to-ones." |
*
* @param {Meetings_Colleagues_CoveredInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_colleagues_covered = /** @type {((inputs?: Meetings_Colleagues_CoveredInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Colleagues_CoveredInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo volgt al je one-to-ones.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo suit déjà tous vos one-to-ones.")
	return /** @type {LocalizedString} */ ("Wundo follows all your one-to-ones.")
});